const statusLabels = {
  Paid: "مدفوع",
  Pending: "قيد الدفع",
  Failed: "فشل الدفع",
  Cancelled: "ملغي",
  Expired: "منتهي",
  Refunded: "مسترد",
  PartiallyRefunded: "مسترد جزئياً",
  NotRequired: "عند الاستلام",
};

const fulfillmentStatuses = new Set([
  "Confirmed",
  "Girabatcom",
  "Printed",
  "Printing Hold",
  "Incomplete",
  "Printlet",
  "TeePlus",
  "Tee Plus",
]);

export function orderCanEnterFulfillment(order) {
  if (!order || order.paymentMethod !== "Online") return true;
  return order.paymentStatus === "Paid";
}

export function isPaidOnline(order) {
  return order?.paymentMethod === "Online" && order?.paymentStatus === "Paid";
}

export function isFulfillmentStatus(status) {
  return fulfillmentStatuses.has(status);
}

export function unpaidFulfillmentMessage(order) {
  const id = order?.orderNumber || order?.orderId || "";
  return `Order #${id} has an unpaid online payment. Payment must be completed before this order can enter fulfillment.`;
}

export default function OrderPaymentBadge({ order }) {
  if (!order?.paymentMethod && !order?.paymentStatus) return null;
  const online = order.paymentMethod === "Online";
  const paidOnline = online && order.paymentStatus === "Paid";
  const unpaidOnline = online && !paidOnline;
  const status = paidOnline
    ? "تم الدفع أونلاين"
    : unpaidOnline
      ? "Payment Pending"
      : (statusLabels[order.paymentStatus] || order.paymentStatus || "");
  return (
    <div className="mt-1">
      <span className={`inline-flex px-2 py-0.5 rounded-full text-[11px] border ${
        unpaidOnline
          ? "bg-amber-50 text-amber-800 border-amber-300"
          : online
            ? "bg-emerald-50 text-emerald-700 border-emerald-200"
            : "bg-slate-50 text-slate-600 border-slate-200"
      }`}>
        {paidOnline ? "Paid Online" : online ? "Kashier" : "COD"} · {status}
      </span>
      {order.paymentTransactionId && (
        <div className="text-[10px] text-slate-500 mt-1">{order.paymentTransactionId}</div>
      )}
    </div>
  );
}
